import { useCallback, useState } from 'react';
import { flatten } from 'lodash';

import { useResizeObserver } from 'src/hooks';

const getVisibleButtonsCount = (toolbarWrapperWidth) => {
  const BUTTON_WIDTH = 24;
  const BUTTON_MARGIN = 4;
  const REQUIRED_RIGHT_EMPTY_WIDTH = 485; // this is a sum of SwitchDisplayMode and centerToolbar section

  const buttonOuterWidth = BUTTON_WIDTH + BUTTON_MARGIN;
  const undoRedoButtonsWidth = 2 * buttonOuterWidth;
  const showMoreButtonWidth = buttonOuterWidth;
  const availableWidthForButtons =
    toolbarWrapperWidth - undoRedoButtonsWidth - showMoreButtonWidth - REQUIRED_RIGHT_EMPTY_WIDTH;

  return Math.floor(availableWidthForButtons / buttonOuterWidth);
};

const getVisibleButtonGroupsCount = (buttonGroups, buttonsCount) => {
  let visibleButtonGroupsCount = 0;
  let groupButtonsCount = 0;

  buttonGroups.every((buttonGroup) => {
    groupButtonsCount += buttonGroup.length;
    const isMoreButtonsThenCanBeDisplayed = groupButtonsCount > buttonsCount;

    if (isMoreButtonsThenCanBeDisplayed) return false;

    visibleButtonGroupsCount += 1;

    return true;
  });

  return visibleButtonGroupsCount;
};

export const useResponsiveFormatButtons = ({ formatButtons, wrapperElement }) => {
  const [visibleButtons, setVisibleButtons] = useState(flatten(formatButtons));
  const [hiddenButtons, setHiddenButtons] = useState([]);

  const onResize = useCallback(
    (element) => {
      const visibleButtonsCount = getVisibleButtonsCount(element.clientWidth);
      const visibleButtonGroupsCount = getVisibleButtonGroupsCount(
        formatButtons,
        visibleButtonsCount
      );
      const visibleButtonGroups = formatButtons.slice(0, visibleButtonGroupsCount);
      const hiddenButtonGroups = formatButtons.slice(visibleButtonGroupsCount);

      setVisibleButtons(flatten(visibleButtonGroups));
      setHiddenButtons(flatten(hiddenButtonGroups));
    },
    [formatButtons]
  );

  useResizeObserver(wrapperElement, onResize);

  return { visibleButtons, hiddenButtons };
};
